import * as angular from 'angular';
import * as _ from 'lodash';

import { TermsToGradMetrics } from '../../../../../ng2/shared/constants/terms-to-grad-metrics.constant';

export class DistanceToGradCtrl {
  static $inject = ['SpinnerModal'];

  public distanceToGradTable;

  constructor(private SpinnerModal: any) {
    this.SpinnerModal.deactivateSpinner();
    this.distanceToGradTable = TermsToGradMetrics;
  }

  $onInit(): void {
    this.distanceToGradTable = this.generateDistanceToGradTable();
  }

  generateDistanceToGradTable() {
    const copy = angular.copy(TermsToGradMetrics);
    _.forOwn(copy, (v: any, k: any) => {
      if (k <= 2) v.style = 'greenCellBg';
      if (k > 2 && k <= 4) v.style = 'yellowCellBg';
      if (k > 4 && k <= 6) v.style = 'orangeCellBg';
      if (k > 6 && k <= 8) v.style = 'redCellBg';
    });
    return copy;
  }
}
